// @ts-nocheck
// biome-ignore-all lint: copied from kimyoDUv2 template and adapted for this app.
import {
	Activity,
	BarChart3,
	BookOpen,
	Building2,
	Calendar,
	CalendarDays,
	Cpu,
	GraduationCap,
	HelpCircle,
	Layers,
	LayoutDashboard,
	Settings,
	Shield,
	Users,
} from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

const navSections = [
	{
		section: "ASOSIY",
		items: [
			{ icon: LayoutDashboard, label: "Dashboard", path: "/" },
			{ icon: Activity, label: "Monitoring", path: "/monitoring", badge: "LIVE" },
		],
	},
	{
		section: "FOYDALANUVCHILAR",
		items: [
			{ icon: GraduationCap, label: "Talabalar", path: "/students" },
			{ icon: BookOpen, label: "O'qituvchilar", path: "/teachers" },
			{ icon: Users, label: "Xodimlar", path: "/employees" },
		],
	},
	{
		section: "BOSHQARUV",
		items: [
			{ icon: Calendar, label: "Davomat", path: "/attendance" },
			{ icon: Building2, label: "Binolar", path: "/buildings" },
			{ icon: Cpu, label: "FaceID", path: "/devices" },
			{ icon: BarChart3, label: "Hisobotlar", path: "/reports" },
		],
	},
	{
		section: "TIZIM",
		items: [
			{ icon: Settings, label: "Sozlamalar", path: "/settings" },
			{ icon: CalendarDays, label: "Bayram kunlari", path: "/settings/holidays" },
		],
	},
];

export function Sidebar({ isOpen = false, onClose }: { isOpen?: boolean; onClose?: () => void }) {
	const location = useLocation();

	const searchParams = new URLSearchParams(location.search);
	const fromPage = searchParams.get("from");
	const backOf = searchParams.get("back");

	// Map ?from=... / ?back=... values to the sidebar item path that should
	// be highlighted.
	const FROM_TO_PATH: Record<string, string> = {
		monitoring: "/monitoring",
		dashboard: "/",
		attendance: "/attendance",
		journal: "/journal",
	};
	const PERSON_ROUTE_PREFIXES = ["/students", "/teachers", "/employees", "/users"];
	const isOnPersonRoute = PERSON_ROUTE_PREFIXES.some((p) => location.pathname.startsWith(p));
	const isOnJournalRoute = location.pathname.startsWith("/journal");
	// When on a profile reached via Journal, prefer the original origin
	// (?back=dashboard|monitoring|...) over `journal` itself, so the
	// originating section stays highlighted across the whole drilldown.
	const effectiveFrom = isOnPersonRoute && backOf ? backOf : fromPage;
	const overridePath =
		effectiveFrom && (isOnPersonRoute || isOnJournalRoute)
			? FROM_TO_PATH[effectiveFrom]
			: undefined;

	const isActive = (path: string) => {
		// When the user navigated into a profile from another section,
		// pin the highlight to the originating section.
		if (overridePath !== undefined) {
			return path === overridePath;
		}

		if (path === "/") return location.pathname === "/" || location.pathname === "/dashboard";
		if (path === "/settings") return location.pathname === "/settings";
		return location.pathname.startsWith(path);
	};

	return (
		<>
			<button
				type="button"
				className={`app-sidebar-overlay ${isOpen ? "app-sidebar-overlay--visible" : ""}`}
				aria-label="Menyuni yopish"
				onClick={onClose}
			/>
			<aside
				className={`app-sidebar ${isOpen ? "app-sidebar--open" : ""}`}
				style={{
					width: "var(--app-sidebar-width, 220px)",
					minWidth: "var(--app-sidebar-width, 220px)",
					background: "var(--app-surface)",
					borderRight: "1px solid var(--app-border)",
					display: "flex",
					flexDirection: "column",
					position: "fixed",
					top: 0,
					left: 0,
					height: "var(--app-sidebar-height, 100vh)",
					zIndex: "var(--app-sidebar-z-index, 50)",
					fontFamily: "'Inter', sans-serif",
					transition: "transform 0.2s ease, background 0.2s ease, border-color 0.2s ease",
				}}
			>
				{/* Logo */}
				<div
					style={{
						height: 60,
						display: "flex",
						alignItems: "center",
						padding: "0 16px",
						borderBottom: "1px solid var(--app-border)",
						gap: 10,
						flexShrink: 0,
					}}
				>
					<div
						style={{
							width: 32,
							height: 32,
							borderRadius: 8,
							background: "linear-gradient(135deg,#00C98D,#0EA5E9)",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Shield size={16} color="#FFFFFF" />
					</div>
					<div>
						<div
							style={{ fontSize: 13, fontWeight: 700, color: "var(--app-text)", lineHeight: 1.2 }}
						>
							DAVOMAT
						</div>
						<div style={{ fontSize: 10, color: "var(--app-text-muted)", lineHeight: 1.2 }}>
							Kimyo-Texnologiya Universiteti
						</div>
					</div>
				</div>

				{/* Navigation */}
				<nav style={{ flex: 1, padding: "6px 8px", overflowY: "auto" }}>
					{navSections.map((section) => (
						<div key={section.section}>
							<div
								style={{
									fontSize: 10,
									fontWeight: 600,
									color: "var(--app-text-muted)",
									letterSpacing: "0.08em",
									textTransform: "uppercase",
									padding: "12px 8px 4px",
								}}
							>
								{section.section}
							</div>
							{section.items.map((item) => {
								const active = isActive(item.path);
								return (
									<NavLink
										key={item.path}
										to={item.path}
										onClick={onClose}
										style={{
											display: "flex",
											alignItems: "center",
											gap: 10,
											padding: "0 10px",
											height: 38,
											borderRadius: 8,
											marginBottom: 1,
											textDecoration: "none",
											position: "relative",
											fontSize: 13,
											fontWeight: 500,
											color: active ? "#00C98D" : "var(--app-text-muted)",
											background: active ? "rgba(0,201,141,0.12)" : "transparent",
											borderLeft: active ? "3px solid #00C98D" : "3px solid transparent",
											transition: "all 0.15s",
										}}
										onMouseEnter={(e) => {
											if (!active) {
												(e.currentTarget as HTMLElement).style.background = "var(--app-surface)";
												(e.currentTarget as HTMLElement).style.color = "var(--app-text-soft)";
											}
										}}
										onMouseLeave={(e) => {
											if (!active) {
												(e.currentTarget as HTMLElement).style.background = "transparent";
												(e.currentTarget as HTMLElement).style.color = "var(--app-text-muted)";
											}
										}}
									>
										<item.icon
											size={15}
											color={active ? "#00C98D" : "var(--app-text-muted)"}
											style={{ flexShrink: 0 }}
										/>
										<span style={{ flex: 1 }}>{item.label}</span>
										{item.badge && (
											<span
												style={{
													display: "flex",
													alignItems: "center",
													gap: 3,
													fontSize: 9,
													fontWeight: 700,
													color: "#34D399",
												}}
											>
												<span
													style={{
														width: 5,
														height: 5,
														borderRadius: "50%",
														background: "#10B981",
														display: "inline-block",
														animation: "pulse 1.5s infinite",
													}}
												/>
												{item.badge}
											</span>
										)}
									</NavLink>
								);
							})}
						</div>
					))}
				</nav>
			</aside>
		</>
	);
}
